var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "141.34 162.24 22.54 162.24 22.54 54.96 197.5 54.96 197.5 162.24 171.58 162.24"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 156.46,
    cy: 121.2,
    r: 20.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.98,
    y1: 81.6,
    x2: 129.82,
    y2: 81.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.98,
    y1: 101.76,
    x2: 102.46,
    y2: 101.76
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.98,
    y1: 121.92,
    x2: 102.46,
    y2: 121.92
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "143.36 137.18 143.36 182.54 157.18 171.6 169.89 182.73 169.89 137.76"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificate);
export default __webpack_public_path__ + "static/media/CERTIFICATE.78aee8e93c9a8c4ed4e5db37822dfa0a.svg";
export { ForwardRef as ReactComponent };